/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Note_Filter_All_StatusInputs */

const vi_sl_note_filter_all_status = /** @type {(inputs: Sl_Note_Filter_All_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả trạng thái`)
};

/**

* @param {Sl_Note_Filter_All_StatusInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_note_filter_all_status = /** @type {((inputs?: Sl_Note_Filter_All_StatusInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Note_Filter_All_StatusInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_note_filter_all_status(inputs)
});